export default __webpack_public_path__ + "static/media/icons8-accounting.4a68d7de.svg";